module.exports = __webpack_public_path__ + "37fcfeb0604f7e7ea4999a9ac6fc5d5e.jpg";